import {
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_REQUEST_SUCCESS,
  FORGOT_PASSWORD_REQUEST_FAILURE
} from "../../utils/constants";

export const handleForgotPasswordRequest = (state, action) => {
  return {
    ...state,
    isLoading: true,
    errorMessage: "",
    successMessage: "",
    redirect: false
  };
};

export const handleForgotPasswordRequestSuccess = (state, action) => {
  const {
    payload: { data }
  } = action;
  if (data.status === 200) {
    return {
      ...state,
      isLoading: false,
      redirect: true,
      errorMessage: "",
      successMessage: "Reset password link has been sent to your email"
    };
  }
  return {
    ...state,
    isLoading: false,
    successMessage: "",
    errorMessage: "Unable to send the reset link. Please try again."
  };
};

export const handleForgotPasswordRequestFailure = (state, action) => {
  const response = action.payload?.response;
  const data = response?.data;
  const status = response?.status;
  let errorMessage = "Unable to send the reset link. Please try again.";

  if (!response) {
    errorMessage = "No internet connection found";
  }

  if (status === 400) {
    if (data?.email) {
      errorMessage = Array.isArray(data.email) ? data.email[0] : data.email;
    } else {
      errorMessage = "An error occurred. Please try again.";
    }
  }

  return {
    ...state,
    isLoading: false,
    redirect: false,
    successMessage: "",
    errorMessage
  };
};

const ACTION_HANDLERS = {
  [FORGOT_PASSWORD_REQUEST]: handleForgotPasswordRequest,
  [FORGOT_PASSWORD_REQUEST_SUCCESS]: handleForgotPasswordRequestSuccess,
  [FORGOT_PASSWORD_REQUEST_FAILURE]: handleForgotPasswordRequestFailure
};

const initialState = {
  redirect: false,
  isLoading: false,
  errorMessage: "",
  successMessage: ""
};

export default function forgotPasswordReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}
